import {register} from '../../../JavaScript/Utils'
import {updateSplidePagination} from '../../../JavaScript/PaginationHelper'

// import type { Splide } from './Carousel.types'

declare global {
  interface Window {
    Splide?: Splide
  }
}

// Temporary solution since the type 'Splide' from Carousel.types does not seem constructable
type Splide = any
type SlideComponent = any

export const MultipurposeBanner = (el: HTMLElement) => {
  const init = () => {
    const Splide = window.Splide
    const sliderThumbnails = el.querySelector('.carousel-thumbnails')
    const sliderMain = el.querySelector('.carousel-main')

    const thumbnails = new Splide(sliderThumbnails, {
      focus: 'center',

      updateOnMove: true,
      perMove: 1,
      perPage: 1.5,
      trimSpace: false,
      gap: '1rem',
      type: 'loop',
      classes: {
        pagination: 'splide__pagination',
        arrows: 'splide__arrows temps',
        arrow: 'splide__arrow temp',
        prev: 'splide__arrow--prev temp-prev',
        next: 'splide__arrow--next temp-next',
      },
      mediaQuery: 'min',
      breakpoints: {
        680: {
          perPage: 2.5
        },
        768: {
          perPage: 2.5,
          gap: 20,
        },
        1024: {
          direction: 'ttb',
          height: 700,
          gap: 12,
          perPage: 1.5,
        }
      }
    });

    el.querySelector('.slider-prev').addEventListener('click', () => {
      thumbnails.go('-${i}');
    });
    el.querySelector('.slider-next').addEventListener('click', () => {
      thumbnails.go('+${i}');
    });

    // RENDER BUGFIX ON LOAD
    thumbnails.on('ready', () => {
      thumbnails.refresh();
    });

    thumbnails.on('pagination:mounted', function (data: { list: { classList: { add: (arg0: string) => void } }; items: any[] }) {

      data.items.forEach(function (item) {
        item.button.textContent = (item.page + 1 < 10 ? '0' : '') + String(item.page + 1);
      });

      updateSplidePagination(0, thumbnails);

    });

    let currentPageIndex = 0;

    thumbnails.on('move', (newIndex: number) => {
      currentPageIndex = newIndex;
      updateSplidePagination(newIndex, thumbnails);
    });

    thumbnails.on('resize', () => {
      updateSplidePagination(currentPageIndex, thumbnails);
    });

    thumbnails.on('click', (slide: SlideComponent, e: MouseEvent) => {
      thumbnails.go(slide.index);
    })

    const main = new Splide(sliderMain, {
      type: 'fade',
      pagination: false,
      arrows: false,
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  }

  init()
}

register('MultipurposeBanner', MultipurposeBanner)

